import { useSyncExternalStore } from "react";

export interface Store<T> {
  getSnapshot: () => T;
  getState: () => T;
  setState: (patch: Partial<T> | ((current: T) => T)) => void;
  subscribe: (listener: () => void) => () => void;
  useStore: () => T;
}

export function createStore<T extends object>(initialState: T): Store<T> {
  let state = initialState;
  const listeners = new Set<() => void>();

  return {
    getSnapshot: () => state,
    getState: () => state,
    setState: (patch) => {
      state = typeof patch === "function" ? patch(state) : { ...state, ...patch };
      for (const listener of listeners) listener();
    },
    subscribe: (listener) => {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
    useStore: () =>
      useSyncExternalStore(
        (listener) => {
          listeners.add(listener);
          return () => listeners.delete(listener);
        },
        () => state,
        () => initialState
      ),
  };
}
